<template>
  <div>
    <v-card class="mx-auto" tile v-if="showCreateClient">
      <v-form ref="form" v-model="formIsValid">
        <v-text-field v-model="name" :rules="[rules.required]" label="Name client"></v-text-field>
        <v-btn color="primary" :disabled="!formIsValid" type="submit" @click="saveClient">submit</v-btn>
      </v-form>
    </v-card>
    <v-card class="mx-auto" tile v-else>
      <v-list>
        <v-list-item v-for="client in clients" v-bind:key="client.name" @click="$router.push(`/clients/${client.id}`)">
          <v-list-item-content>
            <v-list-item-title>
              {{ resolveClientName(client) }}
              <v-chip>{{ client.surveyIds.length }}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn color="primary" @click="showCreateClient = true">Create client</v-btn>
    </v-card>
  </div>
</template>

<script>
import { clientService } from "@/services/client";

export default {
  name: "ClientManager",
  data() {
    return {
      showCreateClient: false,
      formIsValid: true,
      name: null,
      clients: [],
      rules: {
        required: value => !!value || "Verplicht veld"
      }
    };
  },
  methods: {
    resolveClientName(client) {
      if (client.name) {
        return client.name;
      } else {
        return client.id;
      }
    },
    saveClient() {
      clientService.saveClient(this.name)
        // eslint-disable-next-line no-unused-vars
        .then(e => {
          this.loadClients();
          this.showCreateClient = false;
          this.name = null;
        });
    },
    loadClients() {
      clientService.resolveClients().then(e => {
        this.clients = e.data;
      }).catch(error => console.log("error: ", error));
    }
  },
  created() {
    this.loadClients();
  }
};
</script>

